import { useState, useEffect } from "react";
import api from "../Api";

export function useCustomerDetail(id) {
    const [customer, setCustomer] = useState(null);
    const [editableCustomer, setEditableCustomer] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetchCustomerDetails();
        fetchCustomerProjects();
        // eslint-disable-next-line
    }, [id]);

    const fetchCustomerDetails = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/customers/${id}`);
            setCustomer(response.data);
            setEditableCustomer(response.data);
        } catch (err) {
            setError("Er is iets misgegaan met het laden van de klant.");
        } finally {
            setLoading(false);
        }
    };

    const fetchCustomerProjects = async () => {
        try {
            const response = await api.get(`/customers/${id}/projects`);
            setProjects(response.data || []);
        } catch (err) {
            console.error("Could not fetch customer projects:", err);
            // Don't set error state, just log - projects are optional
        }
    };

    const handleSaveClick = async (editableCustomer) => {
        await api.put(`/customers/${id}` , editableCustomer);
        setCustomer(editableCustomer);
        setIsEditing(false);
    };

    return {
        customer,
        editableCustomer,
        setEditableCustomer,
        isEditing,
        setIsEditing,
        loading,
        error,
        projects,
        fetchCustomerDetails,
        handleSaveClick
    };
}

